import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { resetErrorMessage } from 'actions/internal';
import { loadDashboardFilters, loadAccounts } from 'actions/partner';
import { isEqual, get, toLower } from 'lodash';
import TopNavBar from './nav/TopNavBar';
import SubNavBar from './nav/SubNavBar';
import AccountsContainer from './accounts/AccountsContainer';
import AccountsFilterContainer from './accounts/AccountsFilterContainer';

class AccountsPage extends React.Component {
  componentDidMount() {
    this.props.resetErrorMessage();
    this.props.loadDashboardFilters({source: 'init'});
    this.props.loadAccounts(this.props.history.location.search, {source: 'init'});
  }

  componentDidUpdate(prevProps) {
    const isFromNavBar = get(this.props.location, 'state.from') === 'navbar' && get(prevProps.location, 'state.from') !== 'navbar';
    if (isFromNavBar || (!isEqual(prevProps.location, this.props.location) && toLower(this.props.history.action) === 'pop')) {
      this.props.loadAccounts(this.props.history.location.search, {source: 'init'});
    }
  }

  render() {
    if (!this.props.isAuthChecked) return null;
    return (
      <DocumentTitle title='Sparkler - Adults'>
        <div>
          <TopNavBar />
          <SubNavBar />
          <div className="row">
            <div className="column">
              <AccountsFilterContainer />
              <AccountsContainer />
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthChecked: state.auth.isAuthChecked,
  }
}

AccountsPage.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  isAuthChecked: PropTypes.bool.isRequired,
  resetErrorMessage: PropTypes.func.isRequired,
  loadDashboardFilters: PropTypes.func.isRequired,
  loadAccounts: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, { resetErrorMessage, loadDashboardFilters, loadAccounts })(AccountsPage);
